import { MenuItem } from 'primereact/menuitem'

import CustomIcon from './pure/CustomIcon'
import { pi } from './pure/PrimeIcon'
import t from '../../tools/t'

type MenuItemCommand = () => void | Promise<void>

export const getMenuItemProject = (
    command: MenuItemCommand = () => {},
    label: string = t('common_project')
): MenuItem => ({
    icon: pi('folder'),
    label,
    command,
})

export const getMenuItemBoltConnection = (
    command: MenuItemCommand = () => {},
    label: string = t('common_bolt_connection')
): MenuItem => ({
    icon: <CustomIcon name="bolt" margin />,
    label,
    command,
})

export const getMenuItemDuplicate = (
    command: MenuItemCommand = () => {},
    label: string = t('common_duplicate')
): MenuItem => ({
    icon: pi('copy'),
    label,
    command,
})

export const getMenuItemExport = (
    command: MenuItemCommand = () => {},
    label: string = t('common_export')
): MenuItem => ({
    icon: pi('download'),
    label,
    command,
})

export const getMenuItemArchive = (
    command: MenuItemCommand = () => {},
    label: string = t('common_archive')
): MenuItem => ({
    className: 'danger',
    icon: pi('arrow-circle-down'),
    label,
    command,
})

export const getMenuItemRestore = (
    command: MenuItemCommand = () => {},
    label: string = t('common_restore')
): MenuItem => ({
    icon: pi('arrow-circle-up'),
    label,
    command,
})

export const getMenuItemViewQr = (
    command: MenuItemCommand = () => {},
    label: string = t('view_qr_code')
): MenuItem => ({
    icon: pi('qrcode'),
    label,
    command,
})

export const getMenuItemSeparator = () => ({ separator: true })
